var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollowersImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Follow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.66663 3.99984C1.66663 2.71117 2.71129 1.6665 3.99996 1.6665H11C12.2886 1.6665 13.3333 2.71117 13.3333 3.99984V10.9998C13.3333 12.2885 12.2886 13.3332 11 13.3332H3.99996C2.71129 13.3332 1.66663 12.2885 1.66663 10.9998V3.99984Z",
    stroke: "#C3CBD7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.33329 6.91683C6.97762 6.91683 7.49996 6.39449 7.49996 5.75016C7.49996 5.10583 6.97762 4.5835 6.33329 4.5835C5.68896 4.5835 5.16663 5.10583 5.16663 5.75016C5.16663 6.39449 5.68896 6.91683 6.33329 6.91683Z",
    stroke: "#C3CBD7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.33333 8.0835C5.04467 8.0835 4 9.12819 4 10.4168H8.66667C8.66667 9.12819 7.62197 8.0835 6.33333 8.0835Z",
    stroke: "#C3CBD7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.7084 6.3335V8.0835M9.83337 7.2085H11.5834",
    stroke: "#C3CBD7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowersImage);
export default __webpack_public_path__ + "static/media/Followers_image.6d90597ee8c1f784a184baa844db58d1.svg";
export { ForwardRef as ReactComponent };